// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Admin{\n    padding-top: 80px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    background-color: #f7c4c4;\n}\n\n.Admin-table{\n    padding: 20px;\n}\n\n.MuiButton-label{\n    font-family: JosefinSans;\n}\n", ""]);
// Exports
module.exports = exports;
